// @flow

import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { ButtonWrapper, Line } from './atoms';
import Button from '../button';
import PackageCompareTable from './packageCompareTable';
import { getUiSetting, toggleUiBooleanSetting } from '../../store/uiStore';
import {
  getCompareCollapsedButtonText,
  getCompareExpandedButtonText,
} from '../../store/configuratorSettings/selectors';
import type { Theme } from '../../types';

type StateProps = {|
  isTableOpen: boolean,
  openTable: string,
  closeTable: string,
|};

type DispatchProps = {|
  toggleTable: Function,
|};

type OwnProps = {|
  className?: string,
|};

type Props = {|
  ...StateProps,
  ...DispatchProps,
  ...OwnProps,
|};

const ButtonToggle = styled<typeof Button, Theme>(Button)`
  margin: 0;
`;

const PackageCompare = ({
  isTableOpen,
  toggleTable,
  openTable,
  closeTable,
  className,
}: Props) => (
  <div className={className}>
    {isTableOpen && <PackageCompareTable />}
    <ButtonWrapper>
      <Line />
      <ButtonToggle onClick={toggleTable} colors="primary">
        {isTableOpen
          ? <span>{closeTable}</span> : <span>{openTable}</span>}
      </ButtonToggle>
      <Line />
    </ButtonWrapper>
  </div>
);

PackageCompare.defaultProps = {
  className: '',
};

const mapStateToProps = (state): StateProps => ({
  isTableOpen: getUiSetting(state, 'isTableOpen'),
  openTable: getCompareCollapsedButtonText(state),
  closeTable: getCompareExpandedButtonText(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  toggleTable: () => dispatch(toggleUiBooleanSetting('isTableOpen')),
});

export default connect<Props, OwnProps, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(PackageCompare);
